import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Create, Visibility, Add, ReceiptRounded } from '@material-ui/icons';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { Link } from 'react-router-dom';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { wsGetAll } from 'services/WService.js';

import ModalSaleForce from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Zona', accessor: 'base_zone_description' },
  { Header: 'Cód. Almacén', accessor: 'WhsCode' },
  { Header: 'Almacén', accessor: 'WhsName' },
  { Header: 'Mesa', accessor: 'base_bureau_description' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function SaleForce(props) {
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [saleForces, setSaleForces] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);


  async function loadSaleForces() {
    setDataLoading(true);
    let response = await wsGetAll('base/sale-force');
    setDataLoading(false);
    if (response.success) setSaleForces(response.data);
  }

  useEffect(() => {
    loadSaleForces();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <ModalSaleForce
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={loadSaleForces}
      />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.BASE_SALE_FORCES_STORE}
              component={
                <CardIcon color="primary">
                  <ReceiptRounded style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de Fuerza de Venta {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Ferza-de-venta"
              defaultWidth={1200}
              indexRow={[0, 2, 3, 5, 6]}
              widthRow={[180, 140, 300, 120, 0]}
              columns={columns}
              data={saleForces.map((saleForce, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.BASE_SALE_FORCES_SHOW}>
                        <Button justIcon round simple color={props.themeContext.buttonColor}>
                          <Link to={`${saleForce.id}`}>
                            <Visibility />
                          </Link>
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.BASE_SALE_FORCES_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpen(saleForce)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.BASE_SALE_FORCES_DELETED}>
                        <ButtonDelete
                          entity="base/sale-force"
                          id={saleForce.id}
                          reload={loadSaleForces}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  base_zone_description: `${saleForce.base_zone_code} - ${saleForce.base_zone_description}`,
                  WhsCode: saleForce.WhsCode,
                  WhsName: saleForce.WhsName,
                  base_bureau_description: saleForce.base_bureau_description,
                  state: saleForce.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
